export default function formatDateTime(isoString: string) {
  const date = new Date(isoString);

  return date.toLocaleString('de-CH', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  } as const);
}
